"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default2 = exports.default = {
  name: 'LotsTable',
  emits: ['open-edit', 'open-add-row'],
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tableData: function tableData() {
      return Array.isArray(this.data) ? this.data : [];
    }
  },
  methods: {
    formatType: function formatType(type) {
      if (type === 'cut' || type === 'cutting') return 'Estaquia';
      if (type === 'graft' || type === 'grafting') return 'Enxertia';
      return '—';
    },
    formatPlace: function formatPlace(inventories) {
      if (!Array.isArray(inventories) || !inventories.length) return [];
      return inventories.map(function (inventory) {
        var _inventory$section, _inventory$row;
        var sectionName = inventory === null || inventory === void 0 ? void 0 : (_inventory$section = inventory.section) === null || _inventory$section === void 0 ? void 0 : _inventory$section.name;
        var rowName = inventory === null || inventory === void 0 ? void 0 : (_inventory$row = inventory.row) === null || _inventory$row === void 0 ? void 0 : _inventory$row.name;
        var quantity = (inventory === null || inventory === void 0 ? void 0 : inventory.quantity) != null ? " (".concat(inventory.quantity, ")") : '';
        var label = [sectionName, rowName].filter(Boolean).join(' · ') || rowName;
        return label ? "".concat(label).concat(quantity) : null;
      }).filter(Boolean);
    },
    formatDate: function formatDate(value) {
      if (!value) return '--';
      return (0, _moment.default)(value).isValid() ? (0, _moment.default)(value).format('DD/MM/YYYY') : '--';
    },
    formatStageName: function formatStageName(value) {
      if (value === 'planting') {
        return 'Plantio';
      }
      if (value === 'grafting') {
        return 'Enxertia';
      }
      if (value === 'regrafting') {
        return 'Re-enxertia';
      }
      return value;
    },
    formatVarietyName: function formatVarietyName(value) {
      var _value$cutting, _value$rootstock, _value$scion, _value$rootstock3;
      if ((_value$cutting = value.cutting) !== null && _value$cutting !== void 0 && _value$cutting.name) {
        var _value$cutting2;
        return (_value$cutting2 = value.cutting) === null || _value$cutting2 === void 0 ? void 0 : _value$cutting2.name;
      }
      if ((_value$rootstock = value.rootstock) !== null && _value$rootstock !== void 0 && _value$rootstock.name && (_value$scion = value.scion) !== null && _value$scion !== void 0 && _value$scion.name) {
        var _value$rootstock2, _value$scion2;
        return "".concat((_value$rootstock2 = value.rootstock) === null || _value$rootstock2 === void 0 ? void 0 : _value$rootstock2.name, "-").concat((_value$scion2 = value.scion) === null || _value$scion2 === void 0 ? void 0 : _value$scion2.name);
      }
      return (_value$rootstock3 = value.rootstock) === null || _value$rootstock3 === void 0 ? void 0 : _value$rootstock3.name;
    }
  }
};